// extracted by mini-css-extract-plugin
export default {"controlGrid":"AddOrEditBanner_controlGrid__5-Wc8","instructions":"AddOrEditBanner_instructions__EnemT","icon":"AddOrEditBanner_icon__+VpOY"};